import { MUTATIONS } from '../constants';

const mutations = {
    [MUTATIONS.UPLOAD_DOCUMENT.SET_SHIPMENT_DOCUMENT_TYPES](state, data) {
        state.shipmentDocumentTypes = data;
    },

    [MUTATIONS.UPLOAD_DOCUMENT.SET_UPLOAD_RESPONSE](state, data) {
        state.uploadResponse = data;
    }
};

export default mutations;
